<template>
  <div class="grey section">
    <h1 class="ui center aligned header">
      Relevant documents
    </h1>
    <div class="ui hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui middle aligned very relaxed center aligned stackable equal width grid container">
      <div class="column">
        <a class="ui centered card" href="https://github.com/aragon/docs/raw/master/Aragon-One-Pager.pdf" target="_blank" rel="noopener noreferrer">
          <div class="center aligned content">
            <img class="ui small middle aligned image" src="../assets/docs/onepager.png">
            <div class="ui hidden divider"></div>
            <a class="center aligned header">
              One Pager
              <br>
              <i class="us flag"></i>
              <a href="https://github.com/aragon/docs/raw/master/Aragon-One-Pager-CN.pdf"><i class="cn flag"></i></a>
              <a href="https://github.com/aragon/docs/raw/master/Aragon-One-Pager-RU.pdf"><i class="ru flag"></i></a>
            </a>
          </div>
        </a>
      </div>
      <div class="column">
        <a class="ui centered card" href="https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper.pdf">
          <div class="center aligned content">
            <img class="ui small middle aligned image" src="../assets/docs/whitepaper.png">
            <div class="ui hidden divider"></div>
            <a class="center aligned header">
              Whitepaper
              <br>
              <i class="us flag"></i>
              <a href="https://github.com/aragon/whitepaper/raw/master/Aragon%20Whitepaper-CN.pdf"><i class="cn flag"></i></a>
            </a>
          </div>
        </a>
      </div>
      <div class="column">
        <a class="ui centered card" href="https://github.com/aragon/docs/raw/master/Aragon-Development-Plan.pdf" target="_blank" rel="noopener noreferrer">
          <div class="center aligned content">
            <img class="ui small middle aligned image" src="../assets/docs/devplan.png">
            <div class="ui hidden divider"></div>
            <a class="center aligned header">
              Development Plan
              <br>
              <i class="us flag"></i>
            </a>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'docs',
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Docs.vue?7d6bb7d7